import api from './api';
import globalComponents from './globalComponents';

export default {
  api,
  globalComponents,
};
